import config from '../views/config';

export class AuthError extends Error {
  constructor(message = 'Session expired') {
    super(message);
    this.name = 'AuthError';
  }
}

export function getAuthToken() {
  return localStorage.getItem('userToken');
}

export function persistProviderProfile(provider) {
  if (!provider) {
    return;
  }
  const providerId = provider.id || provider._id;
  if (providerId) {
    localStorage.setItem('providerId', String(providerId));
  }
  localStorage.setItem('provider', JSON.stringify(provider));
}

export async function providerFetch(path, options = {}) {
  const token = getAuthToken();
  const headers = {
    Accept: 'application/json',
    ...(options.headers || {}),
  };

  if (token && !headers.Authorization) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (options.body && typeof options.body !== 'string' && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
    options = {
      ...options,
      body: JSON.stringify(options.body),
    };
  }

  const response = await fetch(`${config.apiUrl}${path}`, { ...options, headers });

  if (response.status === 401) {
    throw new AuthError();
  }

  return response;
}

export async function getCurrentProvider() {
  const token = getAuthToken();
  const response = await providerFetch('/providers/get', {
    method: 'POST',
    body: { token },
  });

  if (!response.ok) {
    throw new Error('Could not load provider profile.');
  }

  const provider = await response.json();
  persistProviderProfile(provider);
  return provider;
}

export async function fetchProviderTypes(token) {
  const authToken = token || getAuthToken();
  const response = await providerFetch('/p-types/provider', {
    method: 'POST',
    body: { token: authToken },
  });

  if (!response.ok) {
    return [];
  }

  return response.json();
}

export function handleAuthServiceLogout(setUserLoggedIn, navigate) {
  localStorage.removeItem('userToken');
  localStorage.removeItem('providerId');
  localStorage.removeItem('provider');
  setUserLoggedIn(false);
  if (navigate) {
    navigate('/enter-app');
  }
}
